import React, { useState, useEffect } from 'react';
import News from '../../pages/berita';
import NewsDetail from './detail_berita';

const NewsApp = () => {
  const [currentView, setCurrentView] = useState('list');
  const [selectedSlug, setSelectedSlug] = useState(null);

  useEffect(() => {
    // Handle URL routing
    const handlePopState = () => {
      const path = window.location.pathname;
      if (path.startsWith('/news/') && path.split('/').length === 3) {
        const slug = path.split('/')[2];
        setSelectedSlug(slug);
        setCurrentView('detail');
      } else {
        setCurrentView('list');
        setSelectedSlug(null);
      }
    };

    handlePopState();
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  const handleArticleClick = (slug) => {
    setSelectedSlug(slug);
    setCurrentView('detail');
    window.history.pushState({}, '', `/news/${slug}`);
  };

  const handleBackToList = () => {
    setCurrentView('list');
    setSelectedSlug(null);
    window.history.pushState({}, '', '/news');
  };

  if (currentView === 'detail' && selectedSlug) {
    return <NewsDetail slug={selectedSlug} onBack={handleBackToList} />;
  }

  return <News onArticleClick={handleArticleClick} />;
};

export default NewsApp;